//////////////////
// IMPORTS
//////////////////

// libraries
import React from "react";
import { useQuery } from "@apollo/client";

import { WebSettingsEventColorCodingQueryDocument } from "./graphql/__generated__/WebSettingsEventColorCoding.generated";
import { getToggleState } from "./web-settings-event-color-coding";

// components
import { WebSettingsContainer } from "../web-settings-container";

// constants
import { articleUrls } from "@clockwise/client-commons/src/constants/help-center";

// util
import { getCurrentOrg } from "@util/org.util";
import { page, PageEvents, track, TrackingEvents } from "@util/analytics.util";
import { logger } from "@util/logger.util";

// material-ui
import { FormControl, Switch, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";

// ~-~-~-~-~-~-~-
// Calendar Color Picker
// ~-~-~-~-~-~-~-
const CalendarColorPicker = () => {
  return <div>hi</div>;
};

// ~-~-~-~-~-~-~-
// Event Category Coloring
// ~-~-~-~-~-~-~-
const EventCategoryColoring = () => {
  return (
    <div>
      <CalendarColorPicker />
    </div>
  );
};

// ~-~-~-~-~-~-~-
// Event Category Coloring
// ~-~-~-~-~-~-~-
interface EventColoringSettingsProps {
  org: any;
}

const EventColoringSettings = (props: EventColoringSettingsProps) => {
  const [toggled, setToggled] = React.useState(getToggleState(props.org));

  React.useEffect(() => {
    setToggled(getToggleState(props.org));
  }, [props.org]);

  const onToggleEventColoring = (_event: React.ChangeEvent<HTMLInputElement>, toggle: boolean) => {
    console.log(`toggle: ${toggle}`);
  };

  return (
    <div>
      <div>
        <div>
          <div>
            <FormControl>
              <Switch color="primary" checked={toggled} onChange={onToggleEventColoring} />
            </FormControl>
          </div>
          <div>Enable automatic meeting color-coding</div>
        </div>
      </div>
      {/* <div style={toggled ? {} : { cursor: "not-allowed" }}>
        <div style={toggled ? {} : s.disabled}>
          {eventCategoryColorings.map((ecc, i) => (
            <EventCategoryColoring eventCategoryColoring={ecc} org={org} key={i} />
          ))}
        </div>
      </div> */}
      <EventCategoryColoring />
    </div>
  );
};

// ~-~-~-~-~-~-~-
// Web Settings Event color coding
// ~-~-~-~-~-~-~-
interface WebSettingsEventColorCodingProps {}

const useStyles = makeStyles({
  h1: {
    marginBottom: 44,
  },
  h3: {
    marginBottom: 22,
  },
  divider: {
    margin: "75px 0 40px 0",
  },
});

export const WebSettingsEventColorCoding = (_props: WebSettingsEventColorCodingProps) => {
  const classes = useStyles();

  React.useEffect(() => {
    page(PageEvents.WEB_SETTINGS_EVENT_COLOR_CODING);
  }, []);

  const { loading, data, error } = useQuery(WebSettingsEventColorCodingQueryDocument);

  if (error) {
    logger.error(`failed to load WebSettingsEventColorCoding: ${error}`);
    return (
      <WebSettingsContainer>
        An error occurred while loading Clockwise:
        <br />
        {error.message}
      </WebSettingsContainer>
    );
  }

  if (!data || loading) {
    return <WebSettingsContainer>Loading…</WebSettingsContainer>;
  }

  const viewer = data.viewer;
  const org = getCurrentOrg(viewer);

  if (!org) {
    return <WebSettingsContainer>Loading…</WebSettingsContainer>;
  }

  // ~-~-~-~-~-~-~-
  // Render
  // ~-~-~-~-~-~-~-
  return (
    <WebSettingsContainer>
      <Typography variant="h1" className={classes.h1}>
        Event color coding
      </Typography>
      <Typography variant="h3" className={classes.h3}>
        Event color coding
      </Typography>
      <Typography variant="subtitle1">
        See your priorities at a glance with automatic meeting categorization and color-coding from
        Clockwise. Use the default colors or configure them to your personal preferences.{" "}
        <a
          href={articleUrls.colors}
          target="_blank"
          onClick={() => track(TrackingEvents.WEB_SETTINGS.EVENT_COLOR_CODING.LEARN_MORE_CLICKED)}
        >
          Learn more
        </a>
        .
      </Typography>
      <EventColoringSettings org={org} />
    </WebSettingsContainer>
  );
};
